import { render } from "./404.vue?vue&type=template&id=5e89aee2"
const script = {}
script.render = render

export default script